import Vue from 'vue'

// Example
// {level1:{level2:{level3:'level3'}} };
// checkNested(test, 'level1', 'level2', 'level3') // true
// checkNested(test, 'level1', 'level2', 'foo') // false

Vue.mixin({
  methods: {
    checkNested(obj, level, ...rest) {
      if (obj === undefined) return false
      if (rest.length === 0 && Object.prototype.hasOwnProperty.call(obj, level)) return true
      return this.checkNested(obj[level], ...rest)
    },
  },
})

// Toast Mixin

Vue.mixin({
  methods: {
    toast(toast) {
      this.$buefy.toast.open({
        message: toast.message,
        type: toast.type,
        position: 'is-bottom',
      })
    },
  },
})

// checkObjectForEmpty
Vue.mixin({
  methods: {
    checkObjectForEmpty(obj) {
      return Object.entries(obj).length === 0 && obj.constructor === Object
    },
  },
})

// Convert 1lvl obj keys to array
Vue.mixin({
  methods: {
    convertObjectToArray(someObj) {
      return Object.keys(someObj).map(function(key) {
        return { [key]: someObj[key] }
      })
    },
  },
})
